(function () {
  angular
    .module("akitabox.ui.dialogs.floor.delete")
    .factory("DeleteFloorDialog", DeleteFloorDialog);

  /* @ngInject */
  function DeleteFloorDialog($log, $q, $mdDialog, $mdMedia) {
    var modal = {
      templateUrl: "app/core/ui/dialogs/floor/delete/delete-floor.dialog.html",
      controller: "DeleteFloorDialogController",
      controllerAs: "dialog",
      bindToController: true,
      parent: angular.element(document.body),
      closeTo: angular.element(document.body),
      clickOutsideToClose: false,
      escapeToClose: false,
    };

    // Enable fullscreen mode while on mobile
    if ($mdMedia("sm") || $mdMedia("xs")) {
      modal.fullscreen = true;
    }

    var service = {
      show: show,
    };

    return service;

    // ------------------------
    //   Public Functions
    // ------------------------

    /**
     * Show dialog, `options.locals.floorIDs` and `options.locals.building` are required
     *
     * @param  {Object}                 options     Dialog options
     * @return {Promise<Object|Error}               Promise that resolves with the deleted floors
     */
    function show(options) {
      // Verify we have floorIDs and building locals
      if (
        !options ||
        !options.locals ||
        !options.locals.floorIDs ||
        !options.locals.building
      ) {
        $log.error(
          "DeleteFloorDialog: you must pass in floorIDs and building via locals"
        );
        return $q.reject("Sorry, we weren't able to complete your request.");
      }
      var dialogOptions = angular.extend({}, modal, options);
      return $mdDialog.show(dialogOptions);
    }
  }
})();
